const easing = {
  main: `cubic-bezier(0.1, 0, 0.1, 1)`,
  button: `cubic-bezier(1, 0, 0.5, 1)`,
}

export default easing
